export default "__VITE_ASSET__CQgiUFvd__"